/**
 * Tiny class-name concatenator (no external dependency).
 * Accepts strings, arrays, or objects whose keys are kept when their value is truthy.
 */
export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | Record<string, boolean | null | undefined>
  | ClassValue[]

export function cn(...inputs: ClassValue[]): string {
  const classes: string[] = []
  const push = (value: ClassValue): void => {
    if (!value) return
    if (typeof value === 'string' || typeof value === 'number') {
      classes.push(String(value))
    } else if (Array.isArray(value)) {
      value.forEach(push)
    } else if (typeof value === 'object') {
      Object.entries(value).forEach(([key, enabled]) => {
        if (enabled) classes.push(key)
      })
    }
  }
  inputs.forEach(push)
  return classes.join(' ')
}
